export class MovementUtils {
  public generateRandPosition() {
    let positionx = Math.floor(Math.random() * 95);
    return positionx;
  }
}
